import { queueGuidedSample } from "../guided-sample";
import { LightElement } from "../ui";
import { renderHelpView } from "./help-view";

export class AppHelp extends LightElement {
  connectedCallback(): void {
    this.innerHTML = renderHelpView();
    this.querySelectorAll<HTMLAnchorElement>("[data-help-target]").forEach((link) => this.listen(link, "click", (event) => {
      event.preventDefault();
      this.querySelector(`#${link.dataset.helpTarget}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }));
    this.querySelectorAll<HTMLButtonElement>("[data-try-guided-sample]").forEach((trySample) => this.listen(trySample, "click", () => {
      try {
        queueGuidedSample();
        location.hash = "#/import";
      } catch {
        const status = this.querySelector<HTMLElement>("[data-guided-sample-status]");
        if (status) status.textContent = "This browser blocked temporary sample storage. Open the sample text below and paste it into the importer instead.";
      }
    }));
  }
}

customElements.define("app-help", AppHelp);
